import { all, call, put, takeLatest } from 'redux-saga/effects';
import api from '../../services/api';
import types from '../types';
import notification from '../../services/notification';

function* getTraderInfo() {
  try {
    const { data, status } = yield call(api.traderInfo.getTraderInfo);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_TRADER_INFO_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_TRADER_INFO_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* updateTraderInfo({ payload, callback }) {
  try {
    const { status } = yield call(api.traderInfo.updateTraderInfo, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_TRADER_INFO_SUCCESS, payload });
    notification({ type: 'success', message: 'Success' });

    if (callback) {
      callback();
    }
  } catch (error) {
    yield put({ type: types.UPDATE_TRADER_INFO_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

export function* traderInfos() {
  yield all([
    takeLatest(types.GET_TRADER_INFO_START, getTraderInfo),
    takeLatest(types.UPDATE_TRADER_INFO_START, updateTraderInfo),
  ]);
}
